export function bytesMatch(buffer: Uint8Array, offset: number, bytes: ArrayLike<number>) {
    for (let i = 0; i < bytes.length; i++) {
        if (buffer[offset + i] != bytes[i])
            return false;
    }
    return true;
};

export function replace(buffer: Uint8Array, offset: number, bytes: ArrayLike<number>) {
    for (let i = 0; i < bytes.length; i++) {
        buffer[offset + i] = bytes[i];
    }
};

export function whichBytesMatch(buffer: Uint8Array, offset: number, bytesArray: ArrayLike<number>[]) {
    for (let i = 0; i < bytesArray.length; i++) {
        if (bytesMatch(buffer, offset, bytesArray[i]))
            return i;
    }
    return -1;
};

// https://stackoverflow.com/questions/34309988/byte-array-to-hex-string-conversion-in-javascript
export function byteToHex(byte: number) {
    // convert the possibly signed byte (-128 to 127) to an unsigned byte (0 to 255).
    // if you know, that you only deal with unsigned bytes (Uint8Array), you can omit this line
    const unsignedByte = byte & 0xff;

    // If the number can be represented with only 4 bits (0-15), 
    // the hexadecimal representation of this number is only one char (0-9, a-f). 
    if (unsignedByte < 16) {
        return '0' + unsignedByte.toString(16);
    } else {
        return unsignedByte.toString(16);
    }
}

// bytes is an typed array (Int8Array or Uint8Array)
export function toHexString(bytes: ArrayLike<number>) {
    // Since the .map() method is not available for typed arrays, 
    // we will convert the typed array to an array using Array.from().
    return Array.from(bytes)
        .map(byte => byteToHex(byte))
        .join('')
        .toUpperCase();
}
